<template>
    <div class="certificado-item h-100">

        <div class="content">
            <div class="description">
                <h1 class="title bold text-shadow">¡Eres un Excelente</h1>
                <p class="subtitle text-shadow">Guardián por la Seguridad Vial!</p>
            </div>

            <img src="https://res.cloudinary.com/kiubixdev/image/upload/v1537829436/pandilla-final.png"
                 class="avatar" alt="">

            <div class="row center-xs">
                <div class="col-xs-10 col-sm-8 col-md-6 col-lg-4">
                    <a href="pdfs/certificado_GXSV.pdf" class="btn-primary btn-round"
                       download="certificado_GXSV.pdf">
                        <i class="fa fa-download"></i> Descargar <span class="hidde-xs">certificado</span>
                    </a>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "certificado-gxsv"
    };
</script>

<style lang="sass" scoped>

    .certificado-item
        text-align: center
        .content
            position: relative
            top: 50%
            transform: translateY(-50%)
            .avatar
                width: 50%
                height: auto
                max-width: 100%
                @media only screen and (orientation: portrait)
                    width: 100%
                @media only screen and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)
                    width: 50%
                @media only screen and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)
                    width: 100%
            .description
                color: white
                bottom: 10%
                width: 100%
                z-index: 2
                .text-shadow
                    text-shadow: 4px 4px 2px rgba(0, 0, 0, 0.5)
                .title
                    font-size: 5em
                    margin: 0
                .subtitle
                    font-size: 3em
                    margin: 0
                @media only screen and (max-width: 48em)
                    .title
                        font-size: 1.8em
                    .subtitle
                        font-size: 1.1em
                        margin-bottom: 5px
                @media only screen and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)
                    .title
                        font-size: 2em
                    .subtitle
                        font-size: 1.5em
                        margin-bottom: 5px
                @media only screen and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)
                    .title
                        font-size: 2em
                    .subtitle
                        font-size: 1.5em
                        margin-bottom: 5px
                @media only screen and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)
                    .title
                        font-size: 2.5em
                    .subtitle
                        font-size: 1.5em
                        margin-bottom: 5px
            .btn-content
                height: auto
                margin-top: 5px
                width: 30%
                .btn-primary
                    width: auto
                    -webkit-box-shadow: 0 5px 0 0 rgba(0, 0, 0, 0.2)
                    box-shadow: 0 5px 0 0 rgba(0, 0, 0, 0.2)
                    @media only screen and (min-width: 48em)
                        margin-top: 4px

        .hidde-xs
            display: none
            @media only screen and (min-width: 48em)
                display: inline

</style>
